import HorizontalCarousel from 'components/horizontal-carousel'
import {hybridWorksData} from 'content/home-page'

export default function HybridWorksCarousel() {
  return <HorizontalCarousel data={hybridWorksData} />
}
